import {
  GET_DETAIL_USER_SUCCESS,
  GET_LIST_USER,
  GET_LIST_USER_SUCCESS,
  PAGINATION_DEFAULT,
  SET_LOADING_USER,
} from "../../constants"
import { IUserState } from "../types"

interface ActionProps {
  type: string
  payload: any
}

const initState: IUserState = {
  list: {
    users: [],
    total: 0,
    limit: PAGINATION_DEFAULT.limit,
    offset: PAGINATION_DEFAULT.offset,
  },
  detail: {
    users: {},
  },
  isLoadingRequest: false,
  isDeleteRequest: false,
  isUpdateRequest: false,
  isCreateRequest: false,
}

export const user = (state: IUserState = initState, action: ActionProps) => {
  const { type, payload } = action

  switch (type) {
    case GET_LIST_USER: {
      return {
        ...state,
      }
    }
    case GET_LIST_USER_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          users: payload.data,
          total: payload.total,
        },
      }
    }

    case GET_DETAIL_USER_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          users: payload.data,
        },
      }
    }

    case SET_LOADING_USER: {
      return {
        ...state,
        ...payload,
      }
    }

    default: {
      return state
    }
  }
}
